export const initialErrors = {
  titleMain: String() || null,
  titleEn: String() || null,
  sortOrder: String() || null,
};

export const initialSubdistrict = {
  titleMain: String(),
  titleEn: String(),
  sortOrder: 0,
};

export type initialSubdistrictType = typeof initialSubdistrict;
export type initialErrorsType = typeof initialErrors;

export const SUBDISTRICT_STATUS_OPTIONS = [
  { value: '', labelKey: 'All' },
  { value: 'true', labelKey: 'Active' },
  { value: 'false', labelKey: 'Inactive' },
] as const;

export const subdistrictsTableHead = [
  {
    id: 'titleMain',
    numeric: true,
    label: 'Title (Main)',
  },
  {
    id: 'titleEn',
    numeric: true,
    label: 'Title (English)',
  },
  {
    id: 'sortOrder',
    numeric: true,
    label: 'Sort Order',
  },
  {
    id: 'isActive',
    numeric: true,
    label: 'Status',
  },
  {
    id: 'pCode',
    numeric: true,
    label: 'P-Code',
  },
];
